export default {
    'add-new-product': 'Add new product',
    'pharmaceutical-forms': 'Pharmaceutical forms',
    'add-product': 'Add product',
    'edit-product': 'Edit product',
    'the-product': 'product data?'
}